if (!customElements.get("countdown-timer")) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const timezone = this.dataset.timezone,
        date = this.dataset.date.split("-"),
        day = parseInt(date[0]),
        month = parseInt(date[1]),
        year = parseInt(date[2]);

      let time = this.dataset.time,
        tarhour,
        tarmin;

      if (time != null) {
        time = time.split(":");
        tarhour = parseInt(time[0]);
        tarmin = parseInt(time[1]);
      }

      // Set the date we're counting down to
      let date_string =
        month +
        "/" +
        day +
        "/" +
        year +
        " " +
        tarhour +
        ":" +
        tarmin +
        " GMT" +
        timezone;

      // Time without timezone
      this.countDownDate = new Date(
        year,
        month - 1,
        day,
        tarhour,
        tarmin,
        0,
        0
      ).getTime();

      // Time with timezone
      this.countDownDate = new Date(date_string).getTime();
    }

    connectedCallback() {
      this.autoRepeat = this.dataset.autoRepeat === "true";
      this.autoResetHours = parseInt(this.dataset.autoResetHours) || 0;

      this.updateTime();
    }

    updateTime() {
      const now = new Date().getTime();
      const distance = this.countDownDate - now;

      if (distance < 0 && this.autoRepeat) {
        const resetTime = this.autoResetHours * 60 * 60 * 1000;
        this.countDownDate = now + resetTime;
      }

      this.renderCountdown(distance);

      if (distance >= 0 || this.autoRepeat) {
        requestAnimationFrame(this.updateTime.bind(this));
      }
    }

    renderCountdown(distance) {
      if (distance > 0) {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.querySelector(".days .countdown-timer--column--number").innerHTML = CountdownTimer.addZero(days);
        this.querySelector(".hours .countdown-timer--column--number").innerHTML = CountdownTimer.addZero(hours);
        this.querySelector(".minutes .countdown-timer--column--number").innerHTML = CountdownTimer.addZero(minutes);
        this.querySelector(".seconds .countdown-timer--column--number").innerHTML = CountdownTimer.addZero(seconds);
      }
    }

    static addZero(x) {
      return x < 10 && x >= 0 ? "0" + x : x;
    }
  }

  customElements.define("countdown-timer", CountdownTimer);
}
